import { faDownload } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from '@material-ui/core'
import { ClassNameMap } from '@material-ui/styles'
import { GridColDef } from '@mui/x-data-grid'

import { downloadFile } from './getFiles'

const getColumns = ({ scid, styles }: { scid: number; styles: ClassNameMap }) => {
  const columns: GridColDef[] = [
    {
      field: 'filename',
      headerName: 'File Name',
      renderCell: (params) => (
        <Link
          onClick={() =>
            downloadFile({
              scid,
              fileId: params.id as string,
              fileName: params.value as string,
            })
          }
          className={styles.link}
        >
          <FontAwesomeIcon icon={faDownload} /> {params.value}
        </Link>
      ),
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'createdAt',
      headerName: 'Date Created',
      renderCell: (params) =>
        Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZoneName: 'short',
        }).format(new Date(params.value)),
      sortComparator: (v1, v2) => new Date(v1).getTime() - new Date(v2).getTime(),
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'recordCount',
      headerName: '# Records',
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'lastDownloadedAt',
      headerName: 'Last Downloaded/Sent Date',
      renderCell: (params) => {
        // If not yet downloaded - get sentDate if status == "Successful", otherwise show "-"
        const date = params.value ? params.value : params.row.status === 'successful' ? params.row.sentDate : null
        return date
          ? Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              timeZoneName: 'short',
            }).format(new Date(date))
          : '-'
      },
      sortComparator: (v1, v2) => new Date(v1).getTime() - new Date(v2).getTime(),
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'lastDownloadedByName',
      headerName: 'Last Downloaded/Sent By',
      // If not yet downloaded - show "SFTP" if status == "Successful", otherwise show "-"
      renderCell: (params) =>
        params.value ? params.value : params.row.status === 'successful' && params.row.sentDate ? 'SFTP' : '-',
      flex: 1,
      minWidth: 150,
    },
  ]
  return columns
}

export default getColumns
